/**
 * Initiates our parallax effects
 *
 * @export
 * @class Parallax
 */
import { forEach } from "../helpers/utilities";

export class Parallax {
  /**
   * Loops through our target elements and add's them to the
   * IntersectionObserver. When the elements scroll into view we add a class
   * after a certain delay and stop observing the element
   *
   * @param {string} selector
   * @param {string} visibleClass
   * @memberof Parallax
   */
  constructor() {
    const elements = document.querySelectorAll("[data-parallax-class]");
    if (elements) {
      // Create our observer and callback
      const observer = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]) => {
          forEach(entries, ({}, entry: IntersectionObserverEntry) => {
            const ratio =
              Number(entry.target.getAttribute("data-parallax-ratio")) || 0.1;

            if (entry.intersectionRatio > ratio) {
              const delay =
                Number(entry.target.getAttribute("data-parallax-delay")) *
                  1000 || 0;
              const activeClass = <string>(
                entry.target.getAttribute("data-parallax-class")
              );

              setTimeout(() => {
                entry.target.classList.add(activeClass);
              }, delay);

              // Stop tracking our element
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] }
      );

      // Add elements to our observer
      forEach(elements, ({}, element: Element) => {
        observer.observe(element);
      });
    }
  }
}
